import { environment } from '@qv-env/environment';

export const applicationUrls = {
  deviceActivityUrl: `${environment.envUrls.sa}/device-activity`
};
